import $ from 'jquery';
import {
  addToDataLayerForLinks,
  addToDataLayerForSubmit
} from '../../../home24-shared/tracking/common/helper';
import { getOrderItemData } from '../../../home24-shared/tracking/myAccount/helper';
import * as commonTrackingHelper from '../common/helper';
import BaseTrackingView from '../../core/baseTrackingView';

export default BaseTrackingView.extend({
  events: {
    'submit .js-select-form': 'onSelectActionSubmit',
    'click .js-image-box-link': 'onItemImageClick',
    'click .js-item-name-link': 'onItemNameClick',
    'click .js-order-collapsible': 'onOrderArrowClick',
    'click .js-reclamation-cancel-item': 'onCancelItemClick',
    'click .js-reclamation-return-item': 'onReturnItemClick',
    'click .js-reclamation-correction-item': 'onComplainItemClick',
    'click .js-delivery-question-item': 'onDeliveryQuestionItemClick',
    'click .js-invoice-download': 'onInvoiceDownloadClick',
    'click .js-return-label-download': 'onReturnLabelDownloadClick'
  },

  onSelectActionSubmit: function(e) {
    if (commonTrackingHelper.isGTMLoaded()) {
      const $currentTarget = $(e.currentTarget);
      const actionType = $currentTarget
        .find('.js-action-select')
        .find(':selected')
        .data('action-type');
      addToDataLayerForSubmit(e, {
        event: 'myOrder_selectAction_dropDown',
        eventCategory: 'dropDown',
        eventAction: 'click',
        eventData: {
          placement: 'My Order page',
          label: actionType,
          labelIdentifier: 'Order Info',
          orderId: $currentTarget.closest('.js-order').data('order-id')
        }
      });
    }
  },

  onItemImageClick: function(e) {
    if (commonTrackingHelper.isGTMLoaded()) {
      const $currentTarget = $(e.currentTarget);
      const $orderItem = $currentTarget.closest('.js-order-item');
      const orderData = getOrderItemData($orderItem);

      addToDataLayerForLinks(e, {
        event: 'myOrder_itemPic',
        eventCategory: 'image',
        eventAction: 'click',
        eventData: orderData
      });
    }
  },

  onItemNameClick: function(e) {
    if (commonTrackingHelper.isGTMLoaded()) {
      const $currentTarget = $(e.currentTarget);
      const $orderItem = $currentTarget.closest('.js-order-item');
      const orderData = getOrderItemData($orderItem);

      addToDataLayerForLinks(e, {
        event: 'myOrder_itemName',
        eventCategory: 'link',
        eventAction: 'click',
        eventData: orderData
      });
    }
  },

  onOrderArrowClick: function(e) {
    if ($(event.target).is('select, option')) {
      return;
    }
    if (commonTrackingHelper.isGTMLoaded()) {
      const $currentTarget = $(e.currentTarget);
      const $order = $currentTarget.closest('.js-order');
      const isExpanded = $order.hasClass('active');

      window.dataLayer.push({
        event: 'myOrder_orderArrow',
        eventCategory: 'icon',
        eventAction: isExpanded ? 'collapse' : 'expand',
        eventData: {
          placement: 'My Order page',
          labelIdentifier: 'Order_Info',
          orderId: $order.data('order-id')
        }
      });
    }
  },

  onCancelItemClick: function(e) {
    if (commonTrackingHelper.isGTMLoaded()) {
      const $currentTarget = $(e.currentTarget);
      const $orderItem = $currentTarget.closest('.js-order-item');
      const orderData = getOrderItemData($orderItem);

      addToDataLayerForLinks(e, {
        event: 'myOrder_itemCancellation',
        eventCategory: 'link',
        eventAction: 'click',
        eventData: {
          ...orderData,
          targetUrl: $currentTarget.attr('href'),
          label: 'Cancel Item'
        }
      });
    }
  },

  onReturnItemClick: function(e) {
    if (commonTrackingHelper.isGTMLoaded()) {
      const $currentTarget = $(e.currentTarget);
      const $orderItem = $currentTarget.closest('.js-order-item');
      const orderData = getOrderItemData($orderItem);

      addToDataLayerForLinks(e, {
        event: 'myOrder_itemReturn',
        eventCategory: 'link',
        eventAction: 'click',
        eventData: {
          ...orderData,
          targetUrl: $currentTarget.attr('href'),
          label: 'Return Item'
        }
      });
    }
  },

  onComplainItemClick: function(e) {
    if (commonTrackingHelper.isGTMLoaded()) {
      const $currentTarget = $(e.currentTarget);
      const $orderItem = $currentTarget.closest('.js-order-item');
      const orderData = getOrderItemData($orderItem);

      addToDataLayerForLinks(e, {
        event: 'myOrder_itemComplaint',
        eventCategory: 'link',
        eventAction: 'click',
        eventData: {
          ...orderData,
          targetUrl: $currentTarget.attr('href'),
          label: 'Complaint'
        }
      });
    }
  },

  onDeliveryQuestionItemClick: function(e) {
    if (commonTrackingHelper.isGTMLoaded()) {
      const $currentTarget = $(e.currentTarget);
      const $orderItem = $currentTarget.closest('.js-order-item');
      const orderData = getOrderItemData($orderItem);

      addToDataLayerForLinks(e, {
        event: 'myOrder_deliveryQuestion',
        eventCategory: 'link',
        eventAction: 'click',
        eventData: {
          ...orderData,
          targetUrl: $currentTarget.attr('href'),
          label: 'Question about Delivery Status'
        }
      });
    }
  },

  onInvoiceDownloadClick: function(e) {
    if (commonTrackingHelper.isGTMLoaded()) {
      const $currentTarget = $(e.currentTarget);
      const linkNumber = $currentTarget.index('.js-invoice-download');

      const $lastElement = window.home24.dataTipped._$lastEl;
      const $order = $lastElement.closest('.js-order');
      const orderId = $order.data('order-id');

      addToDataLayerForLinks(e, {
        event: 'myOrder_invoice',
        eventCategory: linkNumber + 1,
        eventAction: 'click',
        eventData: {
          placement: 'My Order Page',
          labelIdentifier: 'Order Info',
          orderId
        }
      });
    }
  },

  onReturnLabelDownloadClick: function(e) {
    if (commonTrackingHelper.isGTMLoaded()) {
      const $currentTarget = $(e.currentTarget);
      const linkNumber = $currentTarget.index('.js-return-label-download');

      const $lastElement = window.home24.dataTipped._$lastEl;
      const $orderItem = $lastElement.closest('.js-order-item');
      const orderData = getOrderItemData($orderItem);

      addToDataLayerForLinks(e, {
        event: 'myOrder_returnLabels',
        eventCategory: linkNumber + 1,
        eventAction: 'click',
        eventData: orderData
      });
    }
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/tracking/myAccount/MyOrdersEvents.js
 **/